import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Sheet, SheetContent } from './ui/sheet';
import { Menu } from 'lucide-react';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#FAFAF9]">
      <aside className="hidden md:flex w-64 flex-col flex-shrink-0 bg-stone-50 border-r border-stone-200">
        <Sidebar />
      </aside>

      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <SheetContent side="left" className="w-64 p-0 bg-stone-50">
          <Sidebar onNavigate={() => setSidebarOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="md:hidden flex items-center gap-4 px-4 py-3 bg-white/80 backdrop-blur-xl border-b border-stone-200 sticky top-0 z-40">
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-xl hover:bg-stone-100 transition-colors"
          >
            <Menu className="w-5 h-5 text-stone-700" strokeWidth={1.5} />
          </button>
          <span className="font-outfit font-semibold text-stone-900">Club Sauna</span>
        </header>

        <main className="flex-1 overflow-auto p-4 md:p-8 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
